import { Login, outLogin, pageInfo } from '@/api/modules/user.js';
import { getUnit, shareParam } from '@/api/modules/public';
import { getCarrierType } from '../api/modules/public';
import { mapSerialize } from '@/utils/mapSerialize';

const actions = {
    systemList({ commit }, data = {}) {
        return new Promise((resolve, reject) => {
            systemList(data).then(
                res => {
                    commit('SET_MENU', res.data);
                    resolve(res);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    login({ commit }, data = {}) {
        console.log('data===>', data);
        return new Promise((resolve, reject) => {
            Login(data).then(
                res => {
                    sessionStorage.setItem('userInfo', JSON.stringify(res.data));
                    commit('SET_USERINFO', res.data);
                    resolve(res);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    unit({ commit }, data = {}) {
        return new Promise((reslove, reject) => {
            getUnit().then(
                res => {
                    const unitHash = {};
                    res.result.forEach(item => {
                        unitHash[item.code] = item;
                    });

                    commit('SET_UNIT', unitHash);
                    reslove(unitHash);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    exType({ commit }, data = {}) {
        return new Promise((resolve, reject) => {
            shareParam({
                code: 'ex_catalog',
                type: 0
            }).then(({ result }) => {
                const exTypeHash = {};
                result.forEach(item => {
                    exTypeHash[item.code] = item;
                });
                commit('SET_EX_TYPE', exTypeHash);
            });
        });
    },
    carrierType({ commit, state }, data = {}) {
        return new Promise((resolve, reject) => {
            getCarrierType().then(
                res => {
                    const hashCarrierType = mapSerialize(res.result);
                    resolve(hashCarrierType);
                    commit('SET_CARRIER_TYPE', hashCarrierType);
                },
                err => {
                    reject(err);
                }
            );
        });
    },
    carrierMode({ commit }, data = {}) {
        return new Promise((resolve, reject) => {
            shareParam({
                code: 'carrier_mode',
                type: 0
            }).then(({ result }) => {
                const modeHash = mapSerialize(result, 'code');
                resolve(modeHash);
                commit('SET_CARRIER_MODE', modeHash);
            });
        });
    }
};

export default actions;
